export default __webpack_public_path__ + "static/media/logo1.e0a189fc.png";